var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54708C",
    d: "M8 0c4.416.005 7.995 3.584 8 8 0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8zm3.534 10.47L8.75 7.69V4.565c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.745l3.224 3.22c.293.292.768.292 1.06-.001.293-.293.293-.768 0-1.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d322c06a133934c47ee646b053234ef9.svg";
export { ForwardRef as ReactComponent };